import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SpsFeedbackBlockComponent } from "../components/feedback-block/sps-feedback-block.component";
import { SpsMicroBlockComponent } from "../components/micro-block/sps-micro-block.component";

@NgModule({
    imports: [CommonModule],
    declarations: [
        SpsFeedbackBlockComponent,
        SpsMicroBlockComponent,
    ],
    exports: [
        SpsFeedbackBlockComponent,
        SpsMicroBlockComponent,
    ],
})
export class SpsFeedbackModule {}
